import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkPlaceSideBet } from '../../redux/actions/sideBetsActions';
import { selectSideBettingState } from '../../redux/selectorFns';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { SideBetButtonLabel } from '../../scenes/poker/panels/sideBetsPanel/sideBetButtonLabel';
import { PanelItem } from '../panelItem';
import { PlayerInfoPlacedSideBetPanelItem } from './playerInfoPlacedSideBetPanelItem';
export const PlayerInfoSideBetPanelItemContainer = ({ playerId }) => {
    const sideBettingState = useAppSelector(selectSideBettingState);
    const isSitting = useAppSelector((state) => !!Object.values(state.poker.seatedPlayers).find((seatedPlayer) => seatedPlayer.id === playerId));
    const isPlayerIn = useAppSelector((state) => {
        const seatedPlayer = Object.values(state.poker.seatedPlayers).find((seatedPlayer) => seatedPlayer.id === playerId);
        return !!seatedPlayer?.isIn;
    });
    const isMySideBetPlaced = useAppSelector((state) => state.sideBets.myPlacedSideBetTargetPlayerId === playerId);
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickPlaceSideBet = useCallback(() => {
        dispatch(thunkPlaceSideBet(playerId, socketSend));
    }, [dispatch, playerId, socketSend]);
    if (isMySideBetPlaced) {
        return _jsx(PlayerInfoPlacedSideBetPanelItem, {});
    }
    if (!isSitting) {
        return null;
    }
    if (sideBettingState === 'off') {
        return null;
    }
    const isDisabled = sideBettingState === 'disabled' || !isPlayerIn;
    return (_jsx(PanelItem, { children: _jsx(Button, { onClick: onClickPlaceSideBet, variant: 'contained', size: 'small', startIcon: _jsx(CasinoRoundedIcon, {}), disabled: isDisabled, children: _jsx(SideBetButtonLabel, {}) }) }));
};
